import React, { Component } from "react";
import CommonModalView from "presentational/common/modals/CommonModalView";
import TXT from "presentational/common/multinational/TXT";
import PropTypes from "prop-types";

class ProfileOptionModalView extends Component {
  static propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    tokenAuthType: PropTypes.PropTypes.oneOf(["google", "cognito_email"])
      .isRequired,
    onMembershipBtnClick: PropTypes.func.isRequired,
    onLinkCopyClick: PropTypes.func.isRequired,
    onLogOutClick: PropTypes.func.isRequired,
    onLogOutForAllDeviceClick: PropTypes.func.isRequired,
    onSettingsBtnClick: PropTypes.func.isRequired
  };

  getButtonList() {
    const {
      tokenAuthType,
      onMembershipBtnClick,
      onLinkCopyClick,
      onLogOutClick,
      onLogOutForAllDeviceClick,
      onSettingsBtnClick
    } = this.props;

    const returnArr = [
      {
        primary: <TXT name="btnList_copyLink" />,
        secondary: <TXT name="msg_copyLinkShareMsgWithoutFunc" />,
        func: onLinkCopyClick
      },
      {
        primary: <TXT name="btnList_membership" />,
        secondary: null,
        func: onMembershipBtnClick
      },
      {
        primary: <TXT name="btnList_settings" />,
        secondary: null,
        func: onSettingsBtnClick
      },
      {
        divider: true
      },
      {
        primary: <TXT name="btnList_logOut" />,
        secondary: null,
        func: onLogOutClick
      },
      tokenAuthType === "cognito_email" && {
        primary: <TXT name="btnList_logOutAllDevice" />,
        secondary: null,
        func: onLogOutForAllDeviceClick
      }
    ].filter(Boolean);

    return returnArr;
  }

  render() {
    const { open, onClose } = this.props;

    return (
      <CommonModalView
        open={open}
        onClose={onClose}
        buttonList={this.getButtonList()}
        firstButtonText={<TXT name="btnModal_close" />}
        firstButtonFunc={onClose}
      />
    );
  }
}

export default ProfileOptionModalView;
